import { Button, type ButtonProperties } from '../../button';
import { Col } from '../../col';
import { Row } from '../../row';

type P = {
  layout?: 'modal' | 'start';
  left?: ButtonProperties;
  right?: ButtonProperties;
  submit?: ButtonProperties;
};

// TODO use this on mostly every Modal footer ideally
// We want ideally to have Form.Actions
const FormActions = ({ layout = 'modal', left, right, submit }: P) => {
  const leftButton = <Button {...left}>{left?.children ?? 'Back'}</Button>;

  const rightButton = <Button {...right}>{right?.children ?? 'Back'}</Button>;

  const submitButton = (
    <Button htmlType="submit" type="primary" {...submit}>
      {submit?.children ?? 'Submit'}
    </Button>
  );

  if (layout === 'modal') {
    return (
      <Row gutter={['xs', 'xs']} justify="space-between">
        <Col>{left ? leftButton : null}</Col>

        <Col>
          <Row gutter={['xs', 'xs']}>
            {right ? <Col>{rightButton}</Col> : null}
            {submit ? <Col>{submitButton}</Col> : null}
          </Row>
        </Col>
      </Row>
    );
  }

  return (
    <Row gutter={['xs', 'xs']} justify="start">
      {left ? <Col>{leftButton}</Col> : null}
      {right ? <Col>{rightButton}</Col> : null}
      {submit ? <Col>{submitButton}</Col> : null}
    </Row>
  );
};

export default FormActions;
